import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'mprd-modem-choice-voip',
  templateUrl: './modem-choice-voip.component.html',
})
export class ModemChoiceVoipComponent {
  @Input() subscriberNumbers: string[] = [];
  @Output() voipCrendentialsModalOpened = new EventEmitter<{ subscriberNumber: string }>();

  onOpened(subscriberNumber: string): void {
    this.voipCrendentialsModalOpened.emit({ subscriberNumber });
  }
}
